module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Box3-b02a4052f54b97b6465562b9fa25f56b.svg";